import { PATH_SEPARATOR } from "../../shared/constants/route-variables.constants";
import { mimeTypeMapping } from "../constants/mimeTypeMapping";

export function getMimeType(extension: string) {
  return mimeTypeMapping[extension.toLowerCase()];
}

export function convertBase64ToBlob(byteString: any, extension?: string) {
  const mimeType = extension ? getMimeType(extension) : "octet/stream";
  const ia = new Uint8Array(byteString.length);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new Blob([ia], { type: mimeType });
}

export function combinePaths(...paths: string[]): string {
  return paths
    .map(path => path?.replace(/(^\/+|\/+$)/g, "") ?? null) // Remove leading and trailing slashes of each element
    .filter(Boolean) // Remove empty strings, null and undefined
    .join(PATH_SEPARATOR);
}
